<template>
  <div class="column_center_around order_method_container" @click="closeTimePicker">
    <text class="title">{{ titleText }}</text>
    <div class="w-full h-[56px] mt-5 border border-[#AAAAAA] rounded-md" :class="{ 'mb-4': isRetailPickUp }">
      <el-date-picker size="large" v-model="selectedDate" type="date" placeholder="選擇日期 *" :disabled-date="disabledDate"
        :editable="false" :clearable="false"></el-date-picker>
    </div>
    <div v-if="!isRetailPickUp" class="w-full h-[56px] mt-2 mb-4 border border-[#AAAAAA] rounded-md relative"
      @click="showTimePicker ? closeTimePicker() : displayTimePicker()">
      <div class="w-full h-full flex items-center justify-between px-3" v-if="!selectedTime">
        <div class="w-full h-full text-[22px] font-normal flex items-center" style="color: rgba(0, 0, 0, 0.3);">
          選擇時間 *
        </div>
        <text class="button-icon size-7 text-[28px] self-center cursor-pointer"
          style="color: #FBCB02;">expand_more</text>
      </div>
      <div class="w-full h-full flex items-center justify-between text-[22px] font-normal px-3"
        style="color: rgba(0, 0, 0, 0.3);" v-else>
        {{ selectedTime }}
        <text class="button-icon size-7 text-[28px] self-center cursor-pointer"
          style="color: #FBCB02;">expand_more</text>
      </div>
      <!-- <el-select id="county-select" size="large" v-model="selectedTime" placeholder="選擇時間">
        <el-option value="選擇時間" disabled selected hidden>
          選擇時間
        </el-option>
        <el-option v-for="(item, index) in timeOptions" :value="item" :key="index">
          {{ item }}
        </el-option>
      </el-select> -->
      <transition name="time-picker-transition">
        <div class="w-[110%] left-[-5%] absolute top-[64px] bg-white grid grid-cols-4 py-4 px-2 rounded-md time-picker"
          v-if="showTimePicker">
          <div class="flex items-center justify-center mx-1.5 px-4 h-11 border border-[#AAAAAA] rounded-md mb-2"
            v-for="(item, index) in timeOptions" :key="index" @click="pickTime(item)">
            {{ item }}
          </div>
        </div>
      </transition>

    </div>

    <!-- 發票資訊分隔線 -->
    <div v-if="shouldShowInvoiceSelector" class="invoice-divider"></div>

    <!-- 整合 InvoiceSelector 組件 -->
    <InvoiceSelector 
      ref="invoiceSelectorRef"
      v-if="shouldShowInvoiceSelector"
      @invoice-updated="handleInvoiceUpdated"
      @validation-error="handleValidationError"
    />

    <!--
    <button class="button" @click="toOrderPage">開始點餐</button>
    -->
    <button class="button" @click="toOrderPage">{{ buttonText }}</button>
  </div>
</template>
<script>
import commonUtilities from '@/utils/common.utils';
import InvoiceSelector from './InvoiceSelector.vue';
import { dayjs } from 'element-plus';
import { mapGetters } from 'vuex'

export default {
  components: {
    InvoiceSelector,
  },
  props: {
    isRetailPickUp: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedDate: "",
      selectedTime: "",
      timeOptions: [],
      disabledDate: (d) => {
        const today = dayjs();
        const tomorrow = dayjs().add(1, 'day');
        const selectedDay = dayjs(d);
        const isSameDay = (day1, day2) => dayjs(day1).isSame(day2, 'day');
        const isBeforeToday = selectedDay.isBefore(today, 'day');

        if (this.preOrderDays !== null) {
          const maxPreOrderDays = Math.max(this.preOrderDays, 0);
          const lastAvailableDay = today.add(Math.max(maxPreOrderDays - 1, 0), 'day');

          if (isBeforeToday || selectedDay.isAfter(lastAvailableDay, 'day')) {
            return true;
          }

          if (isSameDay(d, today)) {
            return !this.todayStoreOpen;
          }

          return this.storeCloseByDate(d);
        }

        // 如果今天營業且營業時間未結束
        if (this.todayStoreOpen) {
          // 如果明天也營業
          if (this.tomorrowStoreOpen) {
            return !isSameDay(d, today) && !isSameDay(d, tomorrow);
          } else {
            // 明天不營業
            return !isSameDay(d, today);
          }
        } else {
          // 今天營業時間已結束
          if (this.tomorrowStoreOpen) {
            return !isSameDay(d, tomorrow);
          } else {
            // 今天和明天都不營業
            return true;
          }
        }
      },
      showTimePicker: false
    };
  },
  computed: {
    titleText() {
      return this.isRetailPickUp ? '選擇取貨日期' : '選擇取餐時間'
    },
    buttonText() {
      return this.isRetailPickUp ? '自取下單' : '自取點餐'
    },
    getCurrentStore() {
      return this.$store.state.basic.currentStore;
    },
    todayEndTime() {
       const endTimes = this.todayBusinessHours.map(item => {
        if (item.endTime.split(':')[0] == '00') {
          return `24:${item.endTime.split(':')[1]}`
        }
        return item.endTime
      }).reduce((a, b) => {
        return a > b ? a : b
      });
      // 取得最晚的營業時間
      return endTimes
    },
    timeOptionStartTomorrow() {
      if (this.todayStoreClose) {
        return true;
      }
      const currentTime = new Date()
      currentTime.setHours(currentTime.getHours() + this.currentPickUpDelayHour, currentTime.getMinutes() + this.currentPickUpDelayMinute)
      const storeEndTime = new Date()
      const [endHour, endMinute] = this.todayEndTime.split(':').map(Number)
      storeEndTime.setHours(endHour, endMinute)
      const lessThanFifteenMinutesOfTodayEndTime = new Date()
      lessThanFifteenMinutesOfTodayEndTime.setHours(endHour, endMinute - 15)
      return currentTime > storeEndTime || currentTime > lessThanFifteenMinutesOfTodayEndTime
    },
    todayStoreOpen() {
      return !this.todayStoreClose && !this.timeOptionStartTomorrow
    },
    tomorrowStoreOpen() {
      return !this.tomorrowStoreClose
    },
    soonestOpenDate() {
      const today = new Date()
      const tomorrow = new Date(today)
      tomorrow.setDate(tomorrow.getDate() + 1)
      if (this.todayStoreOpen) {
        return today
      } else if (this.tomorrowStoreOpen) {
        return tomorrow
      } else {
        return ""
      }
    },
    ...mapGetters('basic', {
      todayBusinessHours: 'todayBusinessHours',
      tomorrowBusinessHours: 'tomorrowBusinessHours',
      todayStoreClose: 'todayStoreClose',
      tomorrowStoreClose: 'tomorrowStoreClose',
      pickUpDelayHour: 'pickUpDelayHour',
      pickUpDelayMinute: 'pickUpDelayMinute',
      retailPickUpDelayHour: 'retailPickUpDelayHour',
      retailPickUpDelayMinute: 'retailPickUpDelayMinute',
      businessHoursByDate: 'businessHoursByDate',
      storeCloseByDate: 'storeCloseByDate',
      preOrderDays: 'preOrderDays'
    }),
    currentPickUpDelayHour() {
      return this.isRetailPickUp ? this.retailPickUpDelayHour : this.pickUpDelayHour
    },
    currentPickUpDelayMinute() {
      return this.isRetailPickUp ? this.retailPickUpDelayMinute : this.pickUpDelayMinute
    },
    // 判斷是否顯示發票選項
    shouldShowInvoiceSelector() {
      return this.$store.getters['basic/enableInvoiceSelector']
    }
  },
  watch: {
    selectedDate() {
      this.closeTimePicker()
      this.timeOptions = []
      this.setupTimeOptions()
      if (this.selectedTime && !this.timeOptions.includes(this.selectedTime)) {
        this.selectedTime = ''
      }
    }
  },
  mounted() {
    let suffixIcons = document.getElementsByClassName('el-select__suffix')
    if (suffixIcons.length > 0) {
      for (const el of suffixIcons) {
        el.innerHTML = '<text id="expand_more" class="button-icon" style="color: #FBCB02; font-size: 28px; width: 28px; height: 28px;">expand_more</text>'
      }
    }
    console.log('todayBusinessHours', this.todayBusinessHours)
    console.log('tomorrowBusinessHours', this.tomorrowBusinessHours)
  },
  methods: {
    setupTimeOptions() {
      // timeOptions 須以目前時間為基準，15分鐘為一個區間
      const today = new Date()
      const selectedDate = this.selectedDate
      if (!selectedDate) return
      const selectedBusinessHours = this.businessHoursByDate(selectedDate)
      // 如果使用者選擇當日日期 
      if (commonUtilities.convertDate(selectedDate) === commonUtilities.convertDate(today)) {
        for (const item of this.todayBusinessHours) {
          this.timeOptionHelper({...item})
        }
      } else {
        for (const item of selectedBusinessHours) {
          this.timeOptionHelper({...item})
        }
      }
      // 過濾相同時間
      this.timeOptions = this.timeOptions.filter((item, index, self) => self.indexOf(item) === index)
      console.log('timeOptions', this.timeOptions)
    },
    timeOptionHelper(item) {
      const today = new Date()
      // 如果選擇日期為今天
      if (commonUtilities.convertDate(this.selectedDate) === commonUtilities.convertDate(today)) {
        const currentHourLargerThanStartHour = Number(item.startTime.split(':')[0]) < today.getHours()
        const currentMinuteLargerThanStartMinute = Number(item.startTime.split(':')[1]) < today.getMinutes()
        const currentHourEqualToStartHour = Number(item.startTime.split(':')[0]) === today.getHours()
        if (currentHourLargerThanStartHour || (currentHourEqualToStartHour && currentMinuteLargerThanStartMinute)) {
          item.startTime = `${today.getHours()}:${today.getMinutes()}`
        }
      }
      // 加入店家設定等候時間
      // 如果等候時間超過 60 分鐘，則將等候時間轉換成小時
      let startHour = parseInt(item.startTime.split(':')[0]) + this.currentPickUpDelayHour;
      let startMinute = parseInt(item.startTime.split(':')[1]) + this.currentPickUpDelayMinute;
      // 考慮加上 pickUpDelayMinute 之後是否會超過 60 分鐘
      if (startMinute >= 60) {
        startHour += 1;
        startMinute -= 60;
      }

      const endHour = parseInt(item.endTime.split(':')[0]);
      const endMinute = parseInt(item.endTime.split(':')[1]);
      console.log('start time', startHour, startMinute)
      console.log('end time', endHour, endMinute)

      for (let hour = startHour; hour <= endHour; hour++) {
        for (let minute = 0; minute < 60; minute += 15) {
          // 如果目前時間已經超過了這個區間，則不顯示該時間選項
          if (hour === startHour && minute < startMinute) {
            continue;
          }
          // 取消15分鐘機制 由商家自行設定等待時間
          // 如果 hour 比對目前時間差一小時，且目前時間在 45 分鐘到 60 分鐘之間，則不顯示該時間選項
          // if (hour - startHour === 1 && minute === 0 && startMinute > 45 && Math.abs(startMinute - 60) < 15) {
          //   continue;
          // }
          // 如果位於目前時間的前 15 分鐘內，則不顯示該時間選項
          // if (!this.timeOptionStartTomorrow && hour === startHour && minute !== 0 && Math.abs(startMinute - minute) < 15) {
          //   continue;
          // }
          if (hour === endHour && minute > endMinute) {
            break;
          }
          let time = `${hour < 10 ? '0' + hour : hour}:${minute < 10 ? '0' + minute : minute}`;
          this.timeOptions.push(time);
        }
      }
    },
    pickTime(time) {
      this.selectedTime = time
      this.closeTimePicker()
    },
    displayTimePicker() {
      if (!this.selectedDate) {
        commonUtilities.createToast('info', '請選擇日期')
        return
      }
      event.stopPropagation();
      event.preventDefault();
      this.showTimePicker = true
    },
    closeTimePicker() {
      event.stopPropagation();
      event.preventDefault();
      this.showTimePicker = false
    },
    toOrderPage() {
      // 觸發所有輸入框失焦，確保發票資料已更新
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur()
      }
      
      // 驗證發票資訊
      if (this.shouldShowInvoiceSelector && this.$refs.invoiceSelectorRef) {
        if (!this.$refs.invoiceSelectorRef.validate()) {
          commonUtilities.createToast('error', '請檢查發票資訊格式')
          return
        }
      }
      
      if (!this.selectedDate) {
        commonUtilities.createToast('error', '請選擇日期')
        return
      }
      // 判斷選則是否有選擇時間以及選擇的時間是否在 timeOptions 內 
      if (!this.isRetailPickUp && (!this.selectedTime || !this.timeOptions.includes(this.selectedTime))) {
        commonUtilities.createToast('error', '請選擇時間')
        return
      }
      
      // 從 store 取得現有的 payment（已包含發票資料）
      const payment = this.$store.state.cart.payment || {}
      
      // 只需要更新 pickUp 特定的欄位
      payment.pickupDate = commonUtilities.convertDate(this.selectedDate)
      payment.pickupTime = this.isRetailPickUp ? null : this.selectedTime
      
      this.$store.commit("cart/setPayment", payment)
      const data = {
        method: 'pickUp'
      }
      this.$store.commit('cart/setTableData', {
        areaId: null,
        tableIndex: -1,
      })
      this.$emit('toOrderPage', data)
    },
    
    // 處理發票資料更新事件
    handleInvoiceUpdated(invoiceData) {
      console.log('pickUp.vue 收到發票資料更新:', invoiceData)
      // InvoiceSelector 已經更新了 Vuex store，這裡只需要記錄日誌
    },
    
    // 處理發票驗證錯誤事件
    handleValidationError(errorMessage) {
      console.error('pickUp.vue 收到發票驗證錯誤:', errorMessage)
      // 可以選擇顯示錯誤訊息給使用者
      // commonUtilities.createToast('error', errorMessage)
    }
  },
};
</script>
<style lang="scss" scoped>
// 修正：調整 el-date-picker 圖示位置（移動到右側而非隱藏）
:deep(.el-date-editor) {
  position: relative;
  
  // 將左側圖示移動到右側
  .el-input__prefix {
    position: absolute;
    right: 4px;
    left: auto;
    z-index: 1;
    
    .el-input__prefix-inner {
      .el-icon {
        color: #FBCB02;
        font-size: 28px;
        width: 28px;
        height: 28px;
      }
    }
  }
  
  // 調整輸入框樣式
  .el-input__inner {
    padding-left: 2px;
    padding-right: 40px;
  }
}

.time-picker-transition-enter-active,
.time-picker-transition-leave-active {
  transition: 0.2s ease-in-out;
}

.time-picker-transition-enter-from,
.time-picker-transition-leave-to {
  max-height: 0;
  opacity: 0;
  transform: scaleY(0);
}

.time-picker-transition-enter-to,
.time-picker-transition-leave-from {
  opacity: 1;
  transform: scaleY(1);
}

.time-picker {
  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.12);
  -webkit-box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.12);
  -moz-box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.12);
}

.invoice-divider {
  width: 100%;
  height: 1px;
  background-color: #DDDDDD;
  margin: 16px 0;
}
</style>
